module.exports = function Worker_fn() {
  return new Worker(__webpack_public_path__ + "js/78dacfda49ed7ccf8c81.worker.js");
}
